export default __webpack_public_path__ + "static/media/heart.16cb96df.svg";